import { render, staticRenderFns } from "./ManageAdministrators.vue?vue&type=template&id=566e14d4&scoped=true&"
import script from "./ManageAdministrators.vue?vue&type=script&lang=ts&"
export * from "./ManageAdministrators.vue?vue&type=script&lang=ts&"
import style0 from "./ManageAdministrators.vue?vue&type=style&index=0&id=566e14d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e14d4",
  null
  
)

export default component.exports